module.exports = __webpack_public_path__ + "static/media/1@2x.2eb81f8d.png";